// extracted by mini-css-extract-plugin
export default {"answersGap":"taskAnswersCheck_answersGap__Nxuj2"};